import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: '',
  type: '',
  isShown: false,
  disableAutoClose: false,
  closeTimeout: 10000,
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    showNotification: (state, action) => {
      const {
        value,
        type,
        disableAutoClose = false,
        closeTimeout = 10000,
      } = action.payload;

      state.value = value;
      state.type = type;
      state.disableAutoClose = disableAutoClose;
      state.closeTimeout = closeTimeout;
      state.isShown = true;
    },

    hideNotification: (state) => {
      state.isShown = false;
    },
  },
});

export const { showNotification, hideNotification } =
  notificationsSlice.actions;

export default notificationsSlice.reducer;
